/**
 * Temporary Scout outage copy. Flip `SCOUT_IS_UNDER_MAINTENANCE` back to
 * `false` when the vendor issue is resolved and the original "Ask Scout"
 * header / chat input should return.
 */
export const SCOUT_IS_UNDER_MAINTENANCE = true;

export const SCOUT_MAINTENANCE_TITLE = "Scout isn't Home Right Now.";

export const SCOUT_MAINTENANCE_DESCRIPTION =
  'Due to third-party vendor changes, Scout is currently undergoing maintenance.';
